import React from 'react';

import { getRandomString } from '../../../../utils';
import { personalData } from '../utils';
import { Pill } from './style';

const PersonalData = (): JSX.Element => {
  return (
    <>
      {personalData.map((value) => (
        <Pill key={getRandomString()}>{value}</Pill>
      ))}
    </>
  );
};

export default PersonalData;
